<template>
  <div class="container">
    <div class="content-wrapper">
      <FormItem
        :queryForm="queryForm"
        :pickerList="pickerList"
        @query="query"
        @interfaceReset="reset"
      ></FormItem>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%; margin-bottom: 20px"
        size="mini"
        stripe
        height="560px"
      >
        <el-table-column width="24" style="padding: 0"></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column
          prop="plate"
          label="车牌号"
          min-width="140"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="上传人"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="车主账号"
          min-width="140"
        ></el-table-column>
        <el-table-column
          prop="orderNum"
          label="工单号"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="stationName"
          label="基站名称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="addTime"
          label="记录时间"
          min-width="180"
        ></el-table-column>
        <el-table-column label="操作" min-width="82" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="btn-options"
              @click="details(scope.row)"
              >发电口照片</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页器 -->
      <el-pagination
        @current-change="handleSizeChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout=" prev, pager, next, jumper"
        :total="total"
      ></el-pagination>

      <!-- 发电口照片弹窗 -->
      <el-dialog :title="title" :visible.sync="dialogVisible" width="60%">
        <div class="dialog-content">
          <el-image
            style="width: 490px; height: 652px"
            :src="url"
            fit="cover"
          ></el-image>
          <!-- <el-row class="img-content">
            <el-row>
              <el-col :span="2.2">经度：</el-col>
              <el-col :span="21.8">120.183702</el-col>
            </el-row>
            <el-row>
              <el-col :span="2.2">纬度：</el-col>
              <el-col :span="21.8">30.110178</el-col>
            </el-row>
            <el-row>
              <el-col :span="2.2">地址：</el-col>
              <el-col :span="21.8">杭州市湘湖演绎产业园</el-col>
            </el-row>
            <el-row>
              <el-col :span="2.2">时间：</el-col>
              <el-col :span="21.8">2021-03-11 13:25:37</el-col>
            </el-row>
            <el-row>
              <el-col :span="2.2">备注：</el-col>
              <el-col :span="21.8">萧山闻堰三江口村</el-col>
            </el-row>
          </el-row> -->
        </div>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span> -->
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FormItem from "@/components/FormItem.vue";
export default {
  name: "PowerGenerationInterfaceRecord",
  components: { FormItem },
  data() {
    return {
      queryForm: {
        plate: "",
        phone: "",
        stationName: "",
        startTime: "",
        endTime: "",
      },
      title: "",
      dialogVisible: false,
      pickerList: [{ start: "开始时间", end: "结束时间" }],
      tableData: [],
      total: 300,
      currentPage: 1,
      limit: 10,
      url: "",
    };
  },
  created() {
    this.getPowerGenerationInterfaceList();
  },
  methods: {
    query() {
      // console.log(data);
      this.getPowerGenerationInterfaceList();
    },
    reset(data) {
      this.queryForm = { ...data };
      this.getPowerGenerationInterfaceList();
    },
    // 当前页数改变时触发
    handleSizeChange(val) {
      console.log("当前页数是：", val);
      this.currentPage = val;
      this.getPowerGenerationInterfaceList();
    },
    details(row) {
      // console.log(row);
      this.title = "发电口照片";
      this.dialogVisible = true;
      this.url = row.url;
    },
    async getPowerGenerationInterfaceList() {
      let _this = this;
      let obj = {};
      obj.phone = _this.queryForm.phone;
      obj.plate = _this.queryForm.plate;
      obj.stationName = _this.queryForm.stationName;
      obj.startTime = _this.queryForm.startTime;
      obj.endTime = _this.queryForm.endTime;
      obj.limit = _this.limit;
      obj.page = _this.currentPage;
      let { data: res } = await _this.$axios.get("/api/dynamo/photo/list", {
        params: obj,
      });
      if (res.code == 1) {
        // console.log(res);
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin: 20px;
  height: calc(100% - 40px);
  background-color: #f8f8f8;
  .content-wrapper {
    height: calc(100% - 60px);
    background: #fff;
    padding: 20px;
    ::v-deep .el-dialog__title {
      color: #333;
    }
    ::v-deep .el-dialog__body {
      padding: 10px 0 20px;
      display: flex;
      justify-content: center;
    }
    .btn-options {
      padding-left: 4px;
    }
    .dialog-content {
      width: 490px;
      height: 652px;
      // position: relative;
      // background-image: url("../../../assets/images/22.jpg");
      // background-size: 100%;
      // background-repeat: no-repeat;
      // background-position: center;
      // .img-content {
      //   width: 50%;
      //   text-align: left;
      //   position: absolute;
      //   left: 28px;
      //   bottom: 37px;
      //   color: #fff;
      //   font-size: 16px;
      //   font-family: Source Han Sans CN;
      //   font-weight: 400;
      //   text-shadow: 2px 2px #000;
      //   // -webkit-text-stroke: 0.4px #000;
      // }
    }
    /** 修改分页器样式开始 **/
    // ::v-deep .el-pagination {
    //   padding: 80px 0 0;
    // }
    // ::v-deep.btn-prev {
    //   border: 1px solid #dbdbdb;
    //   padding: 0;
    //   margin-right: 10px;
    // }
    // ::v-deep ul .number {
    //   border: 1px solid #dbdbdb;
    //   padding: 0;
    //   margin-right: 10px;
    //   &.active {
    //     border: 1px solid #0094ff;
    //   }
    // }
    // ::v-deep ul .el-icon-more {
    //   margin-right: 10px;
    // }
    // ::v-deep.btn-next {
    //   border: 1px solid #dbdbdb;
    //   padding: 0;
    // }
    /** 修改分页器样式结束 **/
  }
}
</style>
